import { render } from "./AdminBusiness.vue?vue&type=template&id=65455628&scoped=true"
import script from "./AdminBusiness.vue?vue&type=script&lang=js"
export * from "./AdminBusiness.vue?vue&type=script&lang=js"

import "./AdminBusiness.vue?vue&type=style&index=0&id=65455628&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65455628"]])

export default __exports__